import { render, staticRenderFns } from "./RefineSearchContainer.vue?vue&type=template&id=670c5c2f&scoped=true&"
import script from "./RefineSearchContainer.vue?vue&type=script&lang=js&"
export * from "./RefineSearchContainer.vue?vue&type=script&lang=js&"
import style0 from "./RefineSearchContainer.vue?vue&type=style&index=0&id=670c5c2f&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670c5c2f",
  null
  
)

export default component.exports